module.exports = __webpack_public_path__ + "img/c2.4468cc4e.jpg";